export const currencies = [
	{ value: 1, label: 'PLN' },
	{ value: 2, label: 'EUR' },
	{ value: 3, label: 'USD' },
]

export const buildingStatuses = {
	'en': [
		{ value: 6, label: 'Preliminary draft' },
		{ value: 4, label: 'Planned' },
		{ value: 5, label: 'On hold' },
		{ value: 2, label: 'Under construction' },
		{ value: 3, label: 'Reconstruction' },
		{ value: 1, label: 'Existing' },
	],
	'pl': [
		{ value: 6, label: 'Wstępny projekt' },
		{ value: 4, label: 'Planowany' },
		{ value: 5, label: 'Wstrzymany' },
		{ value: 2, label: 'W budowie' },
		{ value: 3, label: 'W przebudowie' },
		{ value: 1, label: 'Istniejący' },
	]
}

export const heatingCosts = {
	'en': [
		{ value: 1, label: 'Individually metered' },
		{ value: 2, label: 'Allocated on pro rata' },
		{ value: 3, label: 'Included in service charge' },
	],
	'pl': [
		{ value: 1, label: 'Indywidualnie olicznikowane' },
		{ value: 2, label: 'Alokowane pro rata' },
		{ value: 3, label: 'wliczone w opłaty eksploatacyjne' },
	]
}

export const powerGeneratorOptions = {
	'en': [
		{ value: 1, label: 'No' },
		{ value: 2, label: 'Yes, on underground level' },
		{ value: 3, label: 'Yes, on the roof' },
		{ value: 4, label: 'Yes, outside of the building' },
	],
	'pl': [
		{ value: 1, label: 'Nie' },
		{ value: 2, label: 'Tak, na kondygnacji podziemnej' },
		{ value: 3, label: 'Tak, na dachu Budynku' },
		{ value: 4, label: 'Tak, na zewnątrz Budynku' },
	]
}

export const subleasingOptions = {
	'en': [
		{ value: 1, label: 'Upon written prior notification' },
		{ value: 2, label: 'Upon written prior consent' },
	],
	'pl': [
		{ value: 1, label: 'Za pisemnym powiadomieniem Wynajmującego' },
		{ value: 2, label: 'Za pisemną zgodą Wynajmującego' },
	]
}

export const ITCablingCategories = {
	'en': [
		{ value: 1, label: 'Cat 3' },
		{ value: 2, label: 'Cat 5' },
		{ value: 3, label: 'Cat 5e' },
		{ value: 4, label: 'Cat 6' },
		{ value: 5, label: 'Cat 6a' },
		{ value: 6, label: 'Cat 7' },
		{ value: 7, label: 'Cat 8' },
		{ value: 8, label: 'Other' },
	],
	'pl': [
		{ value: 1, label: 'Cat 3' },
		{ value: 2, label: 'Cat 5' },
		{ value: 3, label: 'Cat 5e' },
		{ value: 4, label: 'Cat 6' },
		{ value: 5, label: 'Cat 6a' },
		{ value: 6, label: 'Cat 7' },
		{ value: 7, label: 'Cat 8' },
		{ value: 8, label: 'Inna' },
	]
}

export const signageCosts = {
	'en': [
		{ value: 1, label: 'Confirmed' },
		{ value: 2, label: 'Not confirmed' },
	],
	'pl': [
		{ value: 1, label: 'Potwierdzamy' },
		{ value: 2, label: 'Nie potwierdzamy' },
	]
}

export const powerGeneratorInfrastructure = {
	'en': [
		{ value: 1, label: 'Building\'s life functions' },
		{ value: 2, label: 'Lifts' },
		{ value: 3, label: 'HVAC for the entire Building' },
		{ value: 4, label: 'Cooling of server rooms (including Tenant\'s server room)' },
		{ value: 5, label: 'Power supply to Tenant\'s server room' },
		{ value: 6, label: 'Power network on tenants\' premises' },
	],
	'pl': [
		{ value: 1, label: 'Podstawowe systemy budynkowe' },
		{ value: 2, label: 'Windy' },
		{ value: 3, label: 'System klimatyzacji dla całego budynku' },
		{ value: 4, label: 'Chłodzenie serwerowni (w tym serwerowni Najemcy)' },
		{ value: 5, label: 'Zasilanie serwerowni Najemcy' },
		{ value: 6, label: 'Sieć energetyczna na powierzchni Najemcy' },
	]
}

export const securityMeasures = {
	'en': [
		{ value: 1, label: 'CCTV' },
		{ value: 2, label: 'Physical security (24h/7/365)' },
		{ value: 3, label: 'Access control' },
	],
	'pl': [
		{ value: 1, label: 'CCTV' },
		{ value: 2, label: 'Obecność pracowników ochrony (24h/365)' },
		{ value: 3, label: 'Kontrola dostępu' },
	]
}

export const incentives = {
	'en': [
		{ value: 1, label: 'office' },
		{ value: 2, label: 'parking' },
		{ value: 3, label: 'storage' },
		{ value: 4, label: 'logo' },
		{ value: 5, label: 'other' },
	],
	'pl': [
		{ value: 1, label: 'biuro' },
		{ value: 2, label: 'parking' },
		{ value: 3, label: 'magazyn' },
		{ value: 4, label: 'logo' },
		{ value: 5, label: 'inne' },
	]
}

export const publicTransport = {
	'en': [
		{ value: 1, label: 'Bus lines (daytime service)' },
		{ value: 2, label: 'Bus lines (nighttime service)' },
		{ value: 3, label: 'Tram lines' },
		{ value: 4, label: 'Metro' },
		{ value: 5, label: 'Fast City Train' },
		{ value: 6, label: 'Suburban trains' },
		{ value: 7, label: 'Regional trains' },
		{ value: 8, label: 'International trains' },
	],
	'pl': [
		{ value: 1, label: 'Autobusy dzienne' },
		{ value: 2, label: 'Autobusy nocne' },
		{ value: 3, label: 'Tramwaje' },
		{ value: 4, label: 'Metro' },
		{ value: 5, label: 'SKM' },
		{ value: 6, label: 'Podmiejskie połączenia kolejowe' },
		{ value: 7, label: 'Międzymiastowe połączenia kolejowe' },
		{ value: 8, label: 'Międzynarodowe połączenia kolejowe' },
	]
}

export const greenCertificates = {
	'pl': [
		{ value: 1, label: 'LEED for Building Design and Construction (LEED BD+C) New Construction' },
		{ value: 2, label: 'LEED for Building Design and Construction (LEED BD+C) Shell & Core' },
		{ value: 3, label: 'LEED for Operation and Maintenance (LEED O+M)' },
		{ value: 4, label: 'LEED for Interior Design and Construction (LEED ID+C)' },
		{ value: 5, label: 'LEED Core & Shell' },
		{ value: 6, label: 'BREEAM New Construction' },
		{ value: 7, label: 'BREEAM In-Use' },
		{ value: 8, label: 'BREEAM Refurbishment & Fit-Out' },
		{ value: 9, label: 'WELL New and Existing Buildings' },
		{ value: 10, label: 'WELL Core & Shell' },
		{ value: 11, label: 'WELL New and Existing Interiors' },
		{ value: 12, label: 'DGNB New Constructionx' },
		{ value: 13, label: 'DGNB Existing Buildings' },
		{ value: 14, label: 'DGNB Interiors' },
	],
	'en': [
		{ value: 1, label: 'LEED for Building Design and Construction (LEED BD+C) New Construction' },
		{ value: 2, label: 'LEED for Building Design and Construction (LEED BD+C) Shell & Core' },
		{ value: 3, label: 'LEED for Operation and Maintenance (LEED O+M)' },
		{ value: 4, label: 'LEED for Interior Design and Construction (LEED ID+C)' },
		{ value: 5, label: 'LEED Core & Shell' },
		{ value: 6, label: 'BREEAM New Construction' },
		{ value: 7, label: 'BREEAM In-Use' },
		{ value: 8, label: 'BREEAM Refurbishment & Fit-Out' },
		{ value: 9, label: 'WELL New and Existing Buildings' },
		{ value: 10, label: 'WELL Core & Shell' },
		{ value: 11, label: 'WELL New and Existing Interiors' },
		{ value: 12, label: 'DGNB New Constructionx' },
		{ value: 13, label: 'DGNB Existing Buildings' },
		{ value: 14, label: 'DGNB Interiors' },
	]
}

export const numberOfOptionsList = [1,2,3]

export const depositOptions = {
	'en': [
		{ value: 1, label: '1-month rent' },
		{ value: 2, label: '2-months rent' },
		{ value: 3, label: 'none' },
	],
	'pl': [
		{ value: 1, label: 'czynsz jednomiesięczny' },
		{ value: 2, label: 'czynsz dwumiesięczny' },
		{ value: 3, label: 'brak' },
	]
}


// WEBPACK FOOTER //
// ./src/utils/_DATA.js